export default __webpack_public_path__ + "static/media/light_03_white.b8d6090e.svg";